module.exports = __webpack_public_path__ + "static/media/vector.e027cd61.svg";